module.exports = __webpack_public_path__ + "media/images/fit_2-a38eee9abf3091c048eb53a5db5a56e5.png";